import React, { useMemo, useState } from 'react';

const THREE_HOURS_MS = 3 * 60 * 60 * 1000;

const getNextRoutineTime = (routine) => {
  const now = new Date();
  const next = new Date();
  next.setHours(routine.hour, routine.minute, 0, 0);
  if (next < now) next.setDate(next.getDate() + 1);
  return next;
};

const Home = ({ routines, onStartRoutine, onOpenSettings, onCreateRoutine }) => {
  const [showMore, setShowMore] = useState(false);

  const { relevantRoutines, otherRoutines } = useMemo(() => {
    const withMeta = routines.map((routine) => {
      const nextTime = getNextRoutineTime(routine);
      const msUntil = nextTime.getTime() - Date.now();
      return { routine, msUntil };
    }).sort((a, b) => a.msUntil - b.msUntil);
    const nextRoutine = withMeta[0]?.routine;
    const relevant = withMeta.filter((item) => (item.msUntil >= 0 && item.msUntil <= THREE_HOURS_MS) || item.routine.id === nextRoutine.id).map((item) => item.routine);
    const other = withMeta.filter((item) => item.msUntil > THREE_HOURS_MS && item.routine.id !== nextRoutine.id).map((item) => item.routine);
    return { relevantRoutines: relevant, otherRoutines: other };
  }, [routines]);

  const renderRoutineCard = (routine) => (
    <div className="routine-card" key={routine.id}>
      <div className="routine-card-head">
        <strong>{routine.title}</strong>
        <span>
          {String(routine.hour).padStart(2, '0')}:{String(routine.minute).padStart(2, '0')}
        </span>
      </div>
      <div className="routine-card-meta">
        {routine.tasks.length} opgaver · {routine.children.length} børn
      </div>
      <button className="big-start" onClick={() => onStartRoutine(routine.id)}>
        Start {routine.title}
      </button>
    </div>
  );

  return (
    <div className="start-page">
      <div className="start-page-card">
        <div className="start-page-hero">🌞🚀✨</div>
        <h1 className="start-page-title">Rutiner</h1>
        <p className="start-page-subtitle">Vælg en rutine for at starte.</p>

        <div className="routine-start-list">
          {relevantRoutines.length > 0 ? (
            relevantRoutines.map(renderRoutineCard)
          ) : (
            <p className="start-page-note">Ingen rutiner har afgangstid inden for de næste 3 timer.</p>
          )}

          {otherRoutines.length > 0 && (
            <button className="show-more-btn" onClick={() => setShowMore((prev) => !prev)}>
              {showMore ? 'Vis færre' : 'Vis flere'}
            </button>
          )}

          {showMore && otherRoutines.map(renderRoutineCard)}
        </div>

        <div className="start-page-actions">
          <button className="big-secondary" onClick={onOpenSettings}>
            ⚙️ Indstillinger
          </button>
          <button className="big-secondary alt" onClick={onCreateRoutine}>
            ➕ Opret ny rutine
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;